import React from "react";
import Swal from "sweetalert2";
import type { SweetAlertIcon } from "sweetalert2";

export interface CustomAlertProps {
  title: string;
  text?: string;
  icon?: SweetAlertIcon;
  confirmButtonText?: string;
  confirmButtonColor?: string;
  onConfirm?: () => void;
  showCancelButton?: boolean;
  cancelButtonText?: string;
  cancelButtonColor?: string;
  onCancel?: () => void;
  onClose?: () => void;
}

const CustomAlert: React.FC<CustomAlertProps> = ({
  title,
  text,
  icon,
  confirmButtonText = "Aceptar",
  confirmButtonColor = "#2563eb", // azul similar al botón primary
  onConfirm,
  showCancelButton = false,
  cancelButtonText = "Cancelar",
  cancelButtonColor = "#e5e7eb", // gris claro similar al botón secondary
  onCancel,
  onClose,
}) => {
  React.useEffect(() => {
    Swal.fire({
      title,
      text,
      icon,
      confirmButtonText,
      confirmButtonColor,
      showCancelButton,
      cancelButtonText,
      cancelButtonColor,
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed && onConfirm) {
        onConfirm();
      } else if (result.isDismissed && onCancel) {
        onCancel();
      }
      if (onClose) {
        onClose();
      }
    });
  }, []);

  return null;
};

export const resetAlert = (): CustomAlertProps => {
  return {
    title: "",
    text: "",
    icon: undefined,
    confirmButtonText: "Aceptar",
    confirmButtonColor: "#2563eb",
    onConfirm: undefined,
    showCancelButton: false,
    cancelButtonText: "Cancelar",
    cancelButtonColor: "#e5e7eb",
    onCancel: undefined,
    onClose: undefined,
  };
};

export default CustomAlert;
